import { useEffect } from 'react';
import { toast, useSonner } from 'sonner';

export const useSonnerErrorDuration = () => {
  const { toasts } = useSonner();

  useEffect(() => {
    toasts.forEach((toastT) => {
      if (toastT.type === 'error') {
        // The first error toast immediately on page entry doesn't pick up the duration, so we retrigger it
        toastT.onAutoClose =
          toastT.duration || toastT.onAutoClose
            ? toastT.onAutoClose
            : () => {
                // Take out the original id since we trigger a new toast
                const { id, ...toastClone } = toastT;
                toast.error(toastClone.title, { ...toastClone });
              };
        toastT.duration ??= Infinity;
      }
    });
  }, [toasts]);
};
